import { FieldValidator, ValidationResult } from './field-validator';

/** Single pole-number entry (Bob Thiele). */
export const POLE_NUMBER_SINGLE_ENTRY =
  /^(?:[A-Za-z]\d{2}\s\d{4}|[A-Za-z]{2}\d{2}\d{4}[A-Za-z]?)$/;

export class PoleNumberValidator extends FieldValidator {
  validate(value: any): ValidationResult {
    const v = String(value ?? '').trim();
    if (!v) {
      return { valid: true };
    }
    if (POLE_NUMBER_SINGLE_ENTRY.test(v)) {
      return { valid: true };
    }
    return {
      valid: false,
      message: 'Enter a valid pole number (e.g. A12 3456 or AB123456).'
    };
  }
}
